var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion-content__client" },
    [
      _c("vs-input", {
        attrs: {
          "full-width": "full-width",
          "prevent-autofill": "prevent-autofill",
          type: "text",
          placeholder: "Email",
          value: _vm.paymentInfo.paypal_email,
          error:
            _vm.paymentInfoSubmitted.PAYPAL &&
            _vm.paymentPaypalValidator.hasError("paypal_email")
        },
        on: {
          input: function($event) {
            return _vm.updatePaymentInfo($event, "paypal_email")
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.paymentInfoSubmitted.PAYPAL &&
                _vm.paymentPaypalValidator.hasError("paypal_email"),
              expression:
                'paymentInfoSubmitted.PAYPAL && paymentPaypalValidator.hasError("paypal_email")'
            }
          ],
          staticClass: "vs-error"
        },
        [_vm._v(_vm._s(_vm.paymentPaypalValidator.firstError("paypal_email")))]
      ),
      !_vm.hideSubmit
        ? _c("vs-button", {
            attrs: {
              text: "save",
              icon: "content-save",
              processing: _vm.processing,
              disabled: _vm.processing
            },
            on: { click: _vm.savePaymentMethod }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }